<template>
  <v-container fluid>
    <v-row>
      <v-col cols="3">
        <v-text-field v-model="patientName"
                      placeholder="Patient name"
                      outlined
                      dense
                      clearable></v-text-field>
      </v-col>
      <v-col cols="3">
        <v-autocomplete v-model="clientIds"
                        :items="availableClients"
                        label="Client"
                        item-text="title"
                        item-value="id"
                        deletable-chips
                        hide-selected
                        multiple
                        small-chips
                        outlined
                        dense
                        no-data-text="No available clients"
                        clearable></v-autocomplete>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <patient-list/>
      </v-col>
    </v-row>
    <v-row class="mt-3">
      <v-col>
        <v-btn color="success" @click="handleCreatePatientButtonClick">Create patient</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import PatientList from '@/components/Patients/Components/PatientList'
import {mapActions, mapState} from 'vuex'

export default {
  name: 'Patients',
  components: {
    PatientList
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapState('clients', {
      availableClients: 'clients'
    }),
    ...mapState('patients', {
      filters: 'filters'
    }),
    patientName: {
      get() {
        return this.filters.name
      },
      set(value) {
        this.changePatientFiltersDebounced({
          filterName: 'searchString',
          value: value
        })
      }
    },
    clientIds: {
      get() {
        return this.filters.clientIds
      },
      set(value) {
        this.changePatientFiltersDebounced({
          filterName: 'clientIds',
          value: value
        })
      }
    },
  },
  methods: {
    ...mapActions('patients', {
      changePatientFilters: 'changePatientFilters'
    }),
    changePatientFiltersDebounced: _.debounce(function (params) {
      return this.changePatientFilters(params)
    }, 200),
    handleCreatePatientButtonClick: function() {
      this.$router.push('/patients/create')
    }
  }
}
</script>

<style scoped>

</style>